import type { WorkspaceItem } from '@bower/shared';
import type { HierarchyNode } from '@bower/shared/types/api';

import type { AclEntityType } from '../hooks/data/useEntityAccess';

/**
 * The ACL entity type of a tree node or a workspace item: a collection is a
 * PROJECT, anything else (a note, a file) an ARTIFACT. Workspace nodes never
 * reach an access control, so they need no case.
 */
export function toAclEntityType(
  target: Pick<HierarchyNode, 'type'> | Pick<WorkspaceItem, 'kind'>,
): AclEntityType {
  const isCollection = 'kind' in target ? target.kind === 'folder' : target.type === 'project';
  return isCollection ? 'PROJECT' : 'ARTIFACT';
}
